<script>
import { useCalendarStore } from "@/views/apps/calendar/useCalendarStore"


export const statusStyles = {
  2: {
    class: 'status-scheduled',
    borderColor: '#C7DCFB',
  },
  // 7: {
  //   class: 'status-confirmed',
  //   borderColor: '#BFE6DA',
  // },
  // 8: {
  //   class: 'status-client-at-salon',
  //   borderColor: '#095221',
  // },
  7: {
    class: 'status-confirmed',
    borderColor: '#095221',
  },
  8: {
    class: 'status-client-at-salon',
    borderColor: '#BFE6DA',
  },
  4: {
    class: 'status-unconfirmed',
    borderColor: '#F7DCA6',
  },
  3: {
    class: 'status-cancelled',
    borderColor: '#D91616',
  },
  6: {
    class: 'status-no-show',
    borderColor: '#D91616',
  },
  1: {
    class: 'status-completed',
    borderColor: '#D6DCE4',
  },
  5: {
    class: 'status-deleted',
    borderColor: '#FAC9C9',
  },
  'store-selling': {
    class: 'status-store-selling',
    borderColor: '#B3AAEF',
  },
}

export const defaultStatusStyle = {
  class: 'status-default',
  borderColor: '#D6DCE4',
}

// 💡 We display the "Scheduled" status as "Unconfirmed"
// when the client is required to confirm the appointment.
export const getStatusStyle = (statusId, clientHasToConfirm = false) =>
  statusStyles[
    clientHasToConfirm && statusId?.toString() === '2'
      ? 4
      : statusId
  ] ?? defaultStatusStyle
</script>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  status: {
    type: Object,
    required: true,
  },
  size: {
    type: String,
    default: 'x-small',
    required: false,
  },
})
const calendarStore = useCalendarStore()

const statusClass = computed(() =>
  getStatusStyle(
    props.status.id,
    calendarStore.viewSettings.clientHasToConfirm,
  ).class,
)
</script>

<template>
  <VChip
    :size="props.size"
    class="break-chip-word px-3 mt-1 line-height-normal"
    :class="statusClass"
  >
    {{ props.status.name }}
  </VChip>
</template>
